import React, { useEffect } from "react";
import {
  Route,
  Switch,
  useHistory,
  useLocation,
} from "react-router-dom";
import MainWrapper from "../MainWrapper";
import NotFound404 from "../../DefaultPage/404/index";
import WrappedRoutes from "./WrappedRoutes";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import Login from "../../../components/Login";
import { useAuth } from "../../../contexts/AuthContext";
import UnderMaintenanceComponent from "../../DefaultPage/UnderMaintenance";
import { changeDirectionToLTR } from "../../../features/direction/directionSlice";
import { changeDirectionToRTL } from "../../../features/direction/directionSlice";

const Router = () => {
  const history = useHistory();
  const dispatch = useDispatch();
  const location = useLocation();
  const vehiclesList = useSelector((state) => state.vehicles.list);
  const groupsList = useSelector((state) => state.groups.list);
  const usersList = useSelector((state) => state.users.list);

  const { isLoggedIn } = useAuth();

  //change from ltr to rtl for arabic
  useEffect(() => {
    const selectedLang = localStorage.getItem("language");
    if (selectedLang === "ar") {
      dispatch(changeDirectionToRTL());
    } else {
      dispatch(changeDirectionToLTR());
    }
  }, []);

  return (
    <MainWrapper>
      <main>
        <Switch>
          <Route path="/404" component={NotFound404} />
          <Route path="/login" component={Login} />
          <Route path="/" component={WrappedRoutes} />
          <Route path="*" component={NotFound404} />
          {/* <Route path="*" component={UnderMaintenanceComponent} /> */}
        </Switch>
        {/* <Redirect to="/dashboard" /> */}
      </main>
    </MainWrapper>
  );
};

export default Router;
